var Layout = Chaplin.Layout.extend({
	regions: {
		'main': ''
	}
});

module.exports = Layout;